import { Editor } from 'react-draft-wysiwyg';
import PropTypes from 'prop-types';

import { toolbarConfig } from '../../../../utils/text-editor-util';

import './rich-text-editor.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const RichTextEditor = ({ editorState, setEditorState }) => {
  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={setEditorState}
      toolbar={toolbarConfig}
      wrapperClassName="rich-text-editor__wrapper"
      editorClassName="rich-text-editor__editor"
      toolbarClassName="rich-text-editor__toolbar"
    />
  );
};

RichTextEditor.propTypes = {
  editorState: PropTypes.shape({}),
  setEditorState: PropTypes.func.isRequired,
};

RichTextEditor.defaultProps = {
  editorState: undefined,
};

export default RichTextEditor;
